var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVector22(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 10,
    viewBox: "0 0 18 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.31273 0H16.0508C16.3115 0.00109314 16.566 0.0794697 16.7822 0.225219C16.9984 0.370969 17.1665 0.577547 17.2653 0.81883C17.364 1.06011 17.389 1.32527 17.3371 1.58076C17.2852 1.83626 17.1587 2.07062 16.9736 2.25421L9.61772 9.61006C9.49517 9.73362 9.34937 9.83169 9.18873 9.89862C9.02809 9.96554 8.85578 10 8.68176 10C8.50773 10 8.33543 9.96554 8.17479 9.89862C8.01415 9.83169 7.86835 9.73362 7.7458 9.61006L0.389949 2.25421C0.204838 2.07062 0.078324 1.83626 0.0264044 1.58076C-0.0255152 1.32527 -0.000509002 1.06011 0.0982619 0.81883C0.197033 0.577547 0.365132 0.370969 0.581304 0.225219C0.797476 0.0794697 1.05201 0.00109314 1.31273 0Z",
    fill: "#F26639"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector22);
export default __webpack_public_path__ + "static/media/Vector (22).be66a0dd8ce3b4da09bb19fb3c980621.svg";
export { ForwardRef as ReactComponent };